module.exports = __webpack_public_path__ + "static/media/ios-musical-note.505bf3a6.svg";